import React, { Component } from 'react'
import { graphql } from 'react-apollo'
import './modal.css'
import { newTask, updateTask, deleteTask } from '@/graphql/mutations/task'
import {
  newSubtask,
  updateSubtask,
  deleteSubtask
} from '@/graphql/mutations/subtask'
import { GC_USER_ID } from '@/constants'
import DeleteModal from '../modals/Delete'

import { Modal, Paper, Checkbox, Button } from 'material-ui'
import List, { ListItem, ListItemText, ListItemIcon } from 'material-ui/List'
import TextField from 'material-ui/TextField'
import { FormGroup, FormControlLabel } from 'material-ui/Form'
import IconButton from 'material-ui/IconButton'
import ClearIcon from 'material-ui-icons/Clear'
import TimelapseIcon from 'material-ui-icons/Timelapse'
import AssignmentIcon from 'material-ui-icons/Assignment'
import ChevronRightIcon from 'material-ui-icons/ChevronRight'

@graphql(newTask, {
  name: 'newTask',
  options: {
    refetchQueries: ['trackerTasksQuery']
  }
})
@graphql(updateTask, {
  name: 'updateTask',
  options: {
    refetchQueries: ['trackerTasksQuery']
  }
})
@graphql(deleteTask, {
  name: 'deleteTask',
  options: {
    refetchQueries: ['trackerTasksQuery']
  }
})
@graphql(newSubtask, {
  name: 'newSubtask',
  options: {
    refetchQueries: ['trackerTasksQuery']
  }
})
@graphql(updateSubtask, {
  name: 'updateSubtask',
  options: {
    refetchQueries: ['trackerTasksQuery']
  }
})
@graphql(deleteSubtask, {
  name: 'deleteSubtask',
  options: {
    refetchQueries: ['trackerTasksQuery']
  }
})
export default class TaskEditModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      open: false,
      OpenDelete: false,
      task: '',
      loadingTask: false,
      loadingDel: false
    }
  }

  // reset state if the seeded prop is updated
  componentWillReceiveProps(nextProps) {
    if (nextProps.open !== this.props.open) {
      this.setState({ open: nextProps.open })
    }

    if (nextProps.task !== this.props.task) {
      this.setState({ task: nextProps.task })
    }
  }

  handleSaveTask = () => {
    this.setState({ loadingTask: true })
    if (this.props.type === 'task') {
      if (this.props.action === 'add') {
        this.props
          .newTask({
            variables: {
              name: this.state.task.name,
              isCompleted: this.state.task.isCompleted,
              minutesTotal: this.state.task.minutesTotal,
              minutesSpent: this.state.task.minutesSpent,
              progressPercentage: this.state.task.progressPercentage,
              trackerId: this.state.task.tracker.id,
              userId: global.localStorage.getItem(GC_USER_ID)
            }
          })
          .then(data => {
            this.props.update(data.data.createTask.id, this.state.task.name)
            this.props.onClose()
            this.setState({
              open: false,
              loadingTask: false
            })
          })
          .catch(error => {
            console.log(error.message + ' Please refresh.')
            this.props.onClose()
            this.setState({
              open: false,
              loadingTask: false
            })
          })
      } else if (this.props.action === 'edit') {
        this.props
          .updateTask({
            variables: {
              name: this.state.task.name,
              isCompleted: this.state.task.isCompleted,
              minutesTotal: this.state.task.minutesTotal,
              minutesSpent: this.state.task.minutesSpent,
              progressPercentage: this.state.task.progressPercentage,
              trackerId: this.state.task.tracker.id,
              userId: global.localStorage.getItem(GC_USER_ID),
              id: this.state.task.id
            }
          })
          .then(() => {
            this.props.onClose()
            this.setState({
              open: false,
              loadingTask: false
            })
          })
          .catch(error => {
            console.log(error.message + ' Please refresh.')
            this.props.onClose()
            this.setState({
              open: false,
              loadingTask: false
            })
          })
      }
    } else if (this.props.type === 'subtask') {
      if (this.props.action === 'add') {
        this.props
          .newSubtask({
            variables: {
              name: this.state.task.name,
              isCompleted: this.state.task.isCompleted,
              minutesTotal: this.state.task.minutesTotal,
              minutesSpent: this.state.task.minutesSpent,
              progressPercentage: this.state.task.progressPercentage,
              taskId: this.state.task.task.id,
              userId: global.localStorage.getItem(GC_USER_ID)
            }
          })
          .then(data => {
            this.props.update(data.data.createSubtask.id, this.state.task.name)
            this.props.onClose()
            this.setState({
              open: false,
              loadingTask: false
            })
          })
          .catch(error => {
            console.log(error.message + ' Please refresh.')
            this.props.onClose()
            this.setState({
              open: false,
              loadingTask: false
            })
          })
      } else if (this.props.action === 'edit') {
        this.props
          .updateSubtask({
            variables: {
              name: this.state.task.name,
              isCompleted: this.state.task.isCompleted,
              minutesTotal: this.state.task.minutesTotal,
              minutesSpent: this.state.task.minutesSpent,
              progressPercentage: this.state.task.progressPercentage,
              taskId: this.state.task.task.id,
              userId: global.localStorage.getItem(GC_USER_ID),
              id: this.state.task.id
            }
          })
          .then(() => {
            this.props.onClose()
            this.setState({
              open: false,
              loadingTask: false
            })
          })
          .catch(error => {
            console.log(error.message + ' Please refresh.')
            this.props.onClose()
            this.setState({
              open: false,
              loadingTask: false
            })
          })
      }
    }
  }

  handleChangeTask = name => event => {
    var newTask = Object.assign({}, this.state.task)
    switch (name) {
      case 'isCompleted':
        newTask[name] = !this.state.task[name]
        break
      case 'minutesTotal':
      case 'minutesSpent':
      case 'progressPercentage':
        newTask[name] =
          event.target.value === '' ? 0 : parseInt(event.target.value, 10)
        break
      default:
        newTask[name] = event.target.value
        break
    }
    this.setState({ task: newTask })
  }

  handleClose = () => {
    this.props.onClose()
    this.setState({
      open: false
    })
  }

  handleOpenDelete = () => {
    this.setState({
      OpenDelete: true
    })
  }

  handleCloseDelete = () => {
    this.setState({
      OpenDelete: false
    })
  }

  handleDelete = id => {
    this.setState({ loadingTask: true, loadingDel: true })
    if (this.props.type === 'task') {
      this.props
        .deleteTask({
          variables: {
            id: id
          }
        })
        .then(() => {
          this.props.onClose()
          this.setState({
            loadingDel: false,
            OpenDelete: false,
            open: false,
            loadingTask: false
          })
        })
        .catch(error => {
          console.log(error.message + ' Please refresh.')
          this.props.onClose()
          this.setState({
            loadingDel: false,
            OpenDelete: false,
            open: false,
            loadingTask: false
          })
        })
    } else if (this.props.type === 'subtask') {
      this.props
        .deleteSubtask({
          variables: {
            id: id
          }
        })
        .then(() => {
          this.props.onClose()
          this.setState({
            loadingDel: false,
            OpenDelete: false,
            open: false,
            loadingTask: false
          })
        })
        .catch(error => {
          console.log(error.message + ' Please refresh.')
          this.props.onClose()
          this.setState({
            loadingDel: false,
            OpenDelete: false,
            open: false,
            loadingTask: false
          })
        })
    }
  }

  render() {
    return (
      <div>
        <Modal
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          open={this.state.open}
          onClose={this.handleClose}
          className="modalAddToday"
          disableAutoFocus
        >
          <Paper className="paperAddTodayEdit" style={{ borderRadius: 16 }}>
            <div id="clearBtnBedTime" className="divAddTpday">
              <div className="divClearButton">
                <IconButton
                  className="btn btn-default btn-style"
                  onClick={this.handleClose}
                >
                  <ClearIcon className="iconClear" />
                </IconButton>
              </div>
              {this.state.task && (
                <List>
                  <ListItem className="listItemSleepTimeComplete">
                    <ListItemIcon>
                      <TimelapseIcon className="editIcons" />
                    </ListItemIcon>
                    <TextField
                      id="name"
                      label={
                        this.props.type === 'task'
                          ? 'Task Name'
                          : 'Subtask Name'
                      }
                      className="textFieldLong"
                      value={this.state.task.name || ''}
                      onChange={this.handleChangeTask('name')}
                      margin="normal"
                      InputLabelProps={{
                        className: 'textFieldTimeTiny'
                      }}
                      inputProps={{
                        className: 'textFieldTimeSmall'
                      }}
                    />
                  </ListItem>

                  <ListItem className="modalContentSmallTime">
                    <ListItemIcon>
                      <AssignmentIcon className="iconSleepAtTimeDate" />
                    </ListItemIcon>
                    <TextField
                      id="estimateMins"
                      label="Mins Estimated"
                      className="textField"
                      value={this.state.task.minutesTotal || ''}
                      onChange={this.handleChangeTask('minutesTotal')}
                      InputLabelProps={{
                        className: 'textFieldTimeTiny'
                      }}
                      inputProps={{
                        className: 'textFieldTimeSmall'
                      }}
                    />
                    <FormGroup row style={{ paddingLeft: 30 }}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={this.state.task.isCompleted}
                            onChange={this.handleChangeTask('isCompleted')}
                            value="isCompleted"
                            style={{ color: 'lightblue' }}
                          />
                        }
                        label="Completed"
                      />
                    </FormGroup>
                  </ListItem>
                  <ListItem className="listItemSleepTimeComplete">
                    <TextField
                      id="minsSpent"
                      label="Mins Spent"
                      className="textField"
                      value={this.state.task.minutesSpent || ''}
                      onChange={this.handleChangeTask('minutesSpent')}
                      InputLabelProps={{
                        className: 'textFieldTimeTiny'
                      }}
                      inputProps={{
                        className: 'textFieldTimeSmall'
                      }}
                    />
                    <TextField
                      id="progressPercentage"
                      label="Progress %"
                      className="textField"
                      value={this.state.task.progressPercentage || ''}
                      onChange={this.handleChangeTask('progressPercentage')}
                      InputLabelProps={{
                        className: 'textFieldTimeTiny'
                      }}
                      inputProps={{
                        className: 'textFieldTimeSmall'
                      }}
                    />
                  </ListItem>
                  <ListItem className="modalContentDone">
                    {this.props.action === 'edit' && (
                      <Button
                        onClick={this.handleOpenDelete}
                        className="iconBtnCheck"
                        size="small"
                      >
                        {' '}
                        <span style={{ color: 'grey', fontSize: 15 }}>
                          Delete
                        </span>
                      </Button>
                    )}
                    <ListItemText />
                    <Button
                      onClick={this.handleClose}
                      className="iconBtnCheck"
                      size="small"
                    >
                      {' '}
                      <span style={{ color: 'grey', fontSize: 15 }}>
                        Cancel
                      </span>
                    </Button>
                    <Button
                      onClick={this.handleSaveTask}
                      className="iconBtnCheck"
                      size="small"
                    >
                      {' '}
                      <span style={{ color: 'grey', fontSize: 15 }}>Save</span>
                      <ChevronRightIcon
                        style={{ color: 'grey', fontSize: 20, paddingLeft: 10 }}
                      />
                    </Button>
                  </ListItem>
                </List>
              )}
            </div>
          </Paper>
        </Modal>
        <DeleteModal
          open={this.state.OpenDelete}
          onClose={this.handleCloseDelete}
          yes={() => this.handleDelete(this.state.task.id)}
          loading={this.state.loadingDel}
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/modals/TaskEdit.js